module.exports = __webpack_public_path__ + "img/tag_blank_front.68f09a12.svg";